import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';

import { PCStoreJsBridge } from '../../../nativeapi';
import styles from './Update.module.less';
import Toast from '../../../components/Toast/Toast';
import { logging } from '../../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const [isEnabled, setIsEnabled] = useState(true);
  const logInfoData = useSelector(selectLogInfo);

  const handleChoose = useCallback(() => {
    PCStoreJsBridge.setAppStoreSwitch({
      type: 5,
      enable: !isEnabled,
      source: 1,
    }).then(res => {
      if (res.code !== 0 || !res.succ) {
        setIsEnabled(isEnabled);
        Toast.error({
          content: '设置失败！',
        });
      } else {
        setIsEnabled(!isEnabled);
        Toast.success({ content: '设置成功！', duration: 2 });
      }
      if (isEnabled) {
        dispatch(
          logging({
            category: 'C',
            action: 'Tankuang_Enabled',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              enabled: false,
              type: 5,
            },
          }),
        );
      } else {
        dispatch(
          logging({
            category: 'C',
            action: 'Tankuang_Enabled',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              enabled: true,
              type: 5,
            },
          }),
        );
      }
    });
  }, [isEnabled]);

  // 修改未知文件设置的默认值
  useEffect(() => {
    PCStoreJsBridge.getAppStoreSwitch({
      type: 5,
      source: 1,
    }).then(res => {
      if (res.succ) {
        setIsEnabled(res.enable);
      }
    });
  }, []);

  return (
    <div className={styles.s_update}>
      <div className="s_line">
        <div className="s_select_title">未知文件设置:</div>
        <div className="s_content">
          <div className="checkbox checkbox_clear" onClick={handleChoose}>
            {isEnabled ? <div className="checked" /> : <div className="no_checked" />}
            <span>开启未知文件推荐设置</span>
          </div>
          <div className="desc desc_margin_top">当您打开未知文件时，为您推荐合适的软件。</div>
        </div>
      </div>
    </div>
  );
});
